import { request } from '@langlois/request';

export async function getById ({ commit }, clubId) {
	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/club/${clubId}`);

		const response = await request.get(url);

		const { ok } = response;

		if (ok) {
			const club = await response.json();

			commit(`club`, {
				...club,
				isSubscribed: true
			});
		}
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Couldn't retrieve the club.`,
			type: `warning`
		}, { root: true });
	}
}
